import { EnumOwnerType } from "gql/generated";

/**
 * Builds an Apollo `context` override that pins the `metadata` request header
 * to a specific operator, for use on mutation calls (e.g. `context: buildOperatorRequestContext(operatorEntityId)`).
 *
 * Needed because the global Apollo link derives `metadata` from the current
 * URL (see `useLoggedInAs`), which is null on pages like the Home dashboard
 * that aren't scoped to a single operator/organization segment. Backend
 * resolvers (e.g. event submission) use this header to attribute the action
 * to an actor, so without this override those actions are silently dropped
 * even though the UI already knows which operator is acting.
 */
export const buildOperatorRequestContext = (operatorEntityId?: string | null) => {
  if (!operatorEntityId) return undefined;
  return {
    headers: {
      metadata: JSON.stringify({
        type: EnumOwnerType.Operator,
        entityId: operatorEntityId,
      }),
    },
  };
};
